import config from "./config.json";

const baseUrl =
  process.env.NODE_ENV === "production"
    ? config.baseUrlProd
    : config.baseUrlDev;

export function login(body) {
  return callPost(baseUrl + "/login", body);
}

export function register(body) {
  return callPostRegister(baseUrl + "/register", body);
}

export function routes() {
  return callGet(baseUrl + "/railway/routes");
}

export function route(station) {
  return callGet(baseUrl + "/railway/route/" + station);
}

export function trains() {
  return callGet(baseUrl + "/railway/trains/");
}

export function trainsByRoute(route) {
  return callGet(baseUrl + "/railway/trains/" + route);
}

export function classes() {
  return callGet(baseUrl + "/railway/classes/");
}

export function schedules() {
  return callGet(baseUrl + "/railway/schedules/");
}

export function validateCard(body) {
  return callPost(baseUrl + "/payment/card", body);
}

export function validatePhone(body) {
  return callPost(baseUrl + "/payment/phone", body);
}

export function createPayment(body) {
  return callPost(baseUrl + "/railway/payment", body);
}

export function makeReservation(body) {
  return callPost(baseUrl + "/railway/reservations", body);
}
export function getReservations(user) {
  return callGet(baseUrl + "/railway/users/" + user + "/reservations/");
}

export function getReservation(rid) {
  return callGet(baseUrl + "/railway/reservations/" + rid);
}

export function cancelReservation(id) {
  return callPost(baseUrl + "/railway/reservations/cancel", { id });
}

export function updateAccount(body, id) {
  return callPut(baseUrl + "/users/" + id, body);
}

export function contact(body) {
  return callPost(baseUrl + "/railway/contact", body);
}

export function getBookedSeatsCount(train, trainClass, date, time) {
  return callGet(
    baseUrl +
      "/railway/reservations/trains/" +
      train +
      "/class/" +
      trainClass +
      "/date/" +
      date +
      "/time/" +
      time
  );
}

export function validateTicket(body) {
  return callPost(baseUrl + "/railway/validate-ticket", body);
}

const callGet = (url) => {
  return fetch(url, {
    method: "GET",
    //body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then(handleres);
};

const token = localStorage.getItem("jwt_token");

const callPostRegister = (url, body) => {
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(handleres);
};

const callPost = (url, body) => {
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then(handleres);
};

const callPut = (url, body) => {
  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then(handleres);
};

export function paymentExternal(body, jwtToken) {
  const externalURL =
    process.env.NODE_ENV === "production"
      ? config.externalPaymentURLProd
      : config.externalPaymentURL;
  return fetch(externalURL, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      "X-Service-Key": "TkrGddfCEzviMuTnQREjsaAXOHPxQMdv",
      "X-Service-Code": "mta0010",
      "X-Service-Slug": "government-warf-ferry",
      Authorization: `Bearer ${jwtToken}`,
    },
  }).then(handleres);
}

export async function govPayLogin(body) {
  // Use the GovPay login endpoint from your Postman collection
  const url = "https://citizens.wan.gov.sl/apis/login"; // Use the real endpoint in production

  const formBody = Object.keys(body)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(body[key]))
    .join("&");

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formBody,
  });

  if (!response.ok) {
    throw new Error("GovPay login failed");
  }

  // The response should contain the token and expiry info
  return response.json();
}

const handleres = (res) => {
  if (res.ok) {
    return res.json();
  } else {
    if (res.status === 404) {
      return Promise.reject();
    } else {
      throw res.json();
    }
  }
};
